import React, { useEffect, useState } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Form, Row, Col } from "react-bootstrap";
import noimage from "../../assets/img/noimage.png";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../../config/config";
import { toast } from "react-toastify";
import { categoryAdd, netWorkAdd, netWorkEdit } from "../../Actions/axios";
import { isEmpty } from "../../Actions/common";

const CategoryAdd = () => {
  const [data, setData] = useState({
  });
  const [err, setErr] = useState({});
  const navigate = useNavigate();

  const onChangeFunc = (e, i) => {
    var { name, value, files } = e.target;
    console.log("🚀 ~ onChangeFunc ~ e.target:", e.target);
  
      setData({ ...data, [name]: files ? files[0] : value });
  
  };
  const validataion = async () => {
    let err = {};
    await Promise.all(
      Object.keys(data)?.map((val) => {
        console.log(val, data[val], data[val]?.name, isEmpty(data[val]?.name));
        if (val == "file") {
          if (val == "file" && isEmpty(data[val]?.name)) {
            err[val] = `${val} is required`;
          }
        } else {
          if (isEmpty(data[val])) {
            err[val] = `${val} is required`;
          }
        }
      })
    );
    setErr(err);
    return err;
  };

  const AddCategoryData = async () => {
    let err = await validataion();
    console.log("🚀 ~ AddCategoryData ~ err:", err)
    if (!isEmpty(err)) {
      return toast.error("Field Required");
    }
    let resp = await categoryAdd(data);
    console.log("🚀 ~ AddCategoryData ~ resp:", resp)
    if (resp?.status) {
      toast.success(resp?.message);
      navigate("/categorylist");
    } else {
      toast.error(resp?.message);
    }
  };



  return (
    <>
      <div className="cmsedit">
        <button className="btn sitebtn mb-4" onClick={() => navigate(-1)}>
          Back
        </button>
        <h1 className="pagehead">Categiry ADD</h1>
        <div className="cardbox">
          <Form>
            <Row>
              <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
                <Form.Group>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    onChange={onChangeFunc}
                    value={data?.name}
                  />
                  {err?.name && <p>{err?.name}</p>}
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} className="mb-4">
                <Form.Group>
                  <Form.Label>Image</Form.Label>
                  <div className="uploadimgbox">
                    <img
                      src={
                        data?.file
                          ? URL.createObjectURL(data?.file)
                          : `${config.Back_URL}network/${data?.logo}`
                      }
                      alt="user"
                      className="img-fluid"
                    />
                    <Form.Control
                      type="file"
                      name="file"
                      onChange={onChangeFunc}
                    />
                  </div>
                </Form.Group>
              </Col>
             
            </Row>
          </Form>
          <button
            type="button"
            onClick={() => {
              AddCategoryData();
            }}
            className="btn sitebtn py-2 px-3 mt-4"
          >
            ADD
          </button>
        </div>
      </div>
    </>
  );
};

export default CategoryAdd;
